module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fuIiA"))).then(() => parcelRequire('5erN3'));